import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

const BILLING_URL = process.env.REACT_APP_BILLING_URL || '';

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    const user = localStorage.getItem('juridic_user');
    if (user) {
      setCurrentUser(JSON.parse(user));
    }

    const savedDarkMode = localStorage.getItem('juridic_darkMode');
    if (savedDarkMode) {
      setDarkMode(JSON.parse(savedDarkMode));
    }

    setLoading(false);
  }, []);

  async function login(username, password) {
    const res = await fetch(`${BILLING_URL}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password }),
    });

    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.error || 'Credenciais inválidas');
    }

    const { token, user } = await res.json();
    const loggedUser = { ...user, token };
    localStorage.setItem('juridic_user', JSON.stringify(loggedUser));
    setCurrentUser(loggedUser);
    return loggedUser;
  }

  function logout() {
    localStorage.removeItem('juridic_user');
    setCurrentUser(null);
  }

  function toggleDarkMode() {
    const newDarkMode = !darkMode;
    setDarkMode(newDarkMode);
    localStorage.setItem('juridic_darkMode', JSON.stringify(newDarkMode));
  }

  const value = {
    currentUser,
    login,
    logout,
    darkMode,
    toggleDarkMode,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
